import { createFileRoute, redirect } from '@tanstack/react-router';

/** Flights is the front door; `/` is only ever a redirect to it. */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    // TanStack Router signals a redirect by throwing its own marker object,
    // not an Error. That is the documented API, not a mistake.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/flights' });
  },
});
